import React from 'react';
const BarraCargando = () => {
    return (<div><progress className="progress is-small is-sistema" max="100">15%</progress></div>  );
}
 
export default BarraCargando;